module.exports = __webpack_public_path__ + "static/media/barbuda-22.b74c6fea.jpg";